import React from "react";
import styles from "./form.module.css"

const FormGroup = ({ inside = false, fullWidth = true, labelText, labelContent, rightContent, children, onClickHeader = () => { }, className = "" }) => {
    return (
        <div className={`${styles.formGroup} ${fullWidth ? styles.fullWidth : ''} ${inside ? styles.inside : ''} ${className}`}>
            <div className={styles.header} onClick={onClickHeader}>
                {labelText &&
                    <div className={styles.labelGroup}>
                        <label>{labelText}</label>
                        {labelContent}
                    </div>
                }
                {rightContent &&
                    <div className={styles.rightContent}>
                        {rightContent}
                    </div>
                }
            </div>
            <div className={styles.body}>
                {children}
            </div>
        </div>
    )
}

export default FormGroup
